define([
        //dojo
        "dojo/_base/declare",
        "dojo/_base/lang",
        "dojo/on",
        "dojo/keys",
        "dojo/query",
        "./_SliderPropertyMixin",
        "./_SliderKeyBoardEventMixin",
        "../ToolstripUtils",
        "./external/HorizontalSlider",
        "./_TooltipMixin",
        "./_WidgetMixin",
        "./_ValidationMixin",
        "mw-form/mixins/property/DisabledMixin",
        "MW/toolstrip/mixins/property/MnemonicMixin",
        "MW/toolstrip/mixins/property/MnemonicKeyNavDirectionMixin",
        "../mixins/AcceptFocusMixin",
        "MW/uiframework/FocusManager"
    ],
    function (declare, lang, on, keys, query, _SliderPropertyMixin, _SliderKeyBoardEventMixin,
              ToolstripUtils, HorizontalSlider, _TooltipMixin, _WidgetMixin, _ValidationMixin, DisabledMixin,
              MnemonicMixin, MnemonicKeyNavDirectionMixin, AcceptFocusMixin, FocusManager) {

        return declare([HorizontalSlider, _SliderPropertyMixin, _SliderKeyBoardEventMixin,
            _TooltipMixin, _WidgetMixin, _ValidationMixin, DisabledMixin, MnemonicMixin, MnemonicKeyNavDirectionMixin, AcceptFocusMixin], {
            /***
             *  OVERRIDING
             * **/
            width: 150,   //TODO: in constructor
            _scaleToParentWidth: true,

            mnemonicKeyNavDirection: "vertical",

            // When ever you move the knob, this function is called
            // Set the value to the nearest step value
            _setPixelValue: function (pixelValue, maxPixels, priorityChange) {

                if (this.disabled || this.readOnly) {
                    return;
                }
                // Calculate step size from steps, minimum and maximum
                var stepSize = (this.maximum - this.minimum) / this.steps, posArray = [],
                    value = (Math.max(Math.min((this.maximum - this.minimum) * pixelValue /
                            maxPixels + this.minimum,
                        this.maximum), this.minimum)), i, closestStep;
                // Compute position array
                for (i = this.minimum; i <= this.maximum; i = i + stepSize) {
                    posArray.push(i);
                }
                // Get the closest value
                closestStep = ToolstripUtils.getClosestValue(posArray, value);

                if (value - closestStep[0] > closestStep[1] - value) {
                    value = closestStep[1];
                } else {
                    value = closestStep[0];
                }
                // Set the new value
                this._setValueAttr(value, priorityChange);

            },
            
            _setCompactAttr: function(compact) {
                this.domNode.classList.toggle("vc-compactSlider", compact);
                this._set("compact", compact);
            },

            _setWidthAttr: function (width) {
                // this.inherited(arguments);
                this._set("width", width);
                this._sliderResize();

            },

            _setMajorTickLabelsAttr: function(majorTickLabels){
                this.inherited(arguments);
                this._sliderResize();
            },

            _sliderResize: function() {
                var majorTickLabelNode, numberOfMajorTickLabels, firstChild, lastChild, firstChildWidth, lastChildWidth, marginLeft, marginRight, parentWidth, width = this.get('width');
                if (width === "100%") {
                    // If labels are passed, the left label and right label are cut off
                    // Add margin left and margin right.  If there is no labels, show nothing.
                    if (this.majorTickLabels === undefined) {
                        if(this.getParent()) {
                            var parentWidth = this.getParent().get("width");
                            this._setWidthOnChildren(parentWidth);
                        }

                    } else if (this.majorTickLabels.length > 0) {
                        // get handle to majorticks
                        majorTickLabelNode = query(".vc-MajorTickLabels", this.containerNode)[0];
                        //CHILDELEMENTCOUNT is faster than using length
                        numberOfMajorTickLabels = majorTickLabelNode.childElementCount;
                        //Get first label
                        firstChild = majorTickLabelNode.children[0];
                        //Get last label
                        lastChild = majorTickLabelNode.children[numberOfMajorTickLabels - 1];
                        // we cannot get width directly as the element is not yet placed in DOM
                        // create dummy node and calculate width for first label and last label
                        firstChildWidth = ToolstripUtils.computeWidth(firstChild.textContent);
                        lastChildWidth = ToolstripUtils.computeWidth(lastChild.textContent);
                        marginLeft = firstChildWidth / 2;
                        marginRight = lastChildWidth / 2;
                        //Get column width
                        parentWidth = this.getParent().get("width");
                        //Set margin left, right and width in pixels (instead of %) to the slider widget
                        this.domNode.style.marginLeft = marginLeft + "px"; 
                        this.domNode.style.marginRight = marginRight + "px";
                        this.domNode.style.width = parentWidth + "px";
                        
                        // Set slider node and labels/ticks node to 100%
                        this.sliderTrackNode.style.width = 100 + "%";
                        this.containerNode.style.width = 100 + "%";
                        this._set("width", parentWidth);
                        // For the thumb and labels to be visible when you are the right end corner
                    } else {
                        parentWidth = this.getParent().get("width");

                        this.domNode.style.marginLeft = 5 + "px";
                        this.domNode.style.marginRight = 5 + "px";
                        this.domNode.style.width = parentWidth + "px";
                        this.sliderTrackNode.style.width = 100 + "%";
                        this.containerNode.style.width = 100 + "%";
                    }
                } else {
                    this.domNode.style.width = width + "px";
                    this._setWidthOnChildren(width);
                }
            },

            _setWidthOnChildren: function(width) {
                var marginLeft, marginRight;
                this.sliderTrackNode.style.width = width - 5 + "px";
                this.containerNode.style.width = width - 5 + "px";

                marginLeft = parseFloat(this.domNode.style.marginLeft);
                if (isNaN(marginLeft) || marginLeft < 5) {
                    this.domNode.style.marginLeft = 5 + "px";
                }

                marginRight = parseFloat(this.domNode.style.marginRight);
                if (isNaN(marginRight) || marginRight < 5) {
                    this.domNode.style.marginRight = 5 + "px";
                }
            },
            _getDomNodeForValidationClasses: function () {
                return this.sliderTrackNode;
            },

            constrainTicksToScaleLimits: function (tickValues, scaleLimits, tickLabels) {
                var newValues = [], newLabels = [], idx;

                // when there is single tick, MATLAB sends a double. The length of double is undefined, so the next loop fails.
                // in this case, move the tick into an array so that the rest of processing continues without error.
                if (tickValues.length === undefined) {
                    tickValues = [tickValues];
                }
                for (idx = 0; idx < tickValues.length; idx += 1) {
                    if (tickValues[idx] >= scaleLimits[0] && tickValues[idx] <= scaleLimits[1]) {
                        newValues[newValues.length] = tickValues[idx];

                        if (tickLabels !== undefined) {
                            newLabels[newLabels.length] = tickLabels[idx];
                        }
                    }
                }
                if (tickLabels !== undefined) {
                    return {'ticks': newValues, 'labels': newLabels};
                } else {
                    return {'ticks': newValues};
                }
            },

            /*
             * Overiding App designer's fix to geck 1061541
             */

            _adjustLabelContainerPositioning: function () {
                // check to handle when major-tick labels are set to empty or
                // when font properties are updated when there are no major-tick labels
                if (this.majorTickLabelDijit) {
                    var labelContainerNodes = query(".dijitRuleLabelContainerH",
                        this.majorTickLabelDijit.domNode);
                    var majorTickLabelsLength = labelContainerNodes.length;

                    labelContainerNodes.forEach(function (labelContainerNode, index) {
                        var labelPosition = ToolstripUtils.computeWidth(labelContainerNode.children[0].textContent);
                        //  negative margin to push it to the left by half the width of the text content
                        // thereby center-aligning it below the tick
                        var marginLeftForLabelContainer = labelPosition / 2 * -1;
                        labelContainerNode.style.marginLeft = marginLeftForLabelContainer + "px";

                        if (index === 0) {
                            // g1918637: Set the marginLeft of the slider's DOM node to make sure that the left most
                            // major tick label does not go out of the toolstrip section.
                            this.domNode.style.marginLeft = (marginLeftForLabelContainer * -1) + "px";
                        }

                        if (index === majorTickLabelsLength - 1) {
                            // g1918637: Set the marginRight of the slider's DOM node to make sure that the right
                            // most major tick label does not go out of the toolstrip section.
                            this.domNode.style.marginRight = (marginLeftForLabelContainer * -1) + "px";
                        }
                    }.bind(this));
                }
            },


            /***
             *  END OVERRIDING
             * **/
            postCreate: function () {
                this.inherited(arguments);
                //Geck 1240732: Initially had mouseup event . But dragging and leaving mouse outside of slider does not work.

                this.own(on(this, "mouseup", lang.hitch(this, function () {
                    this.valueChanged({value: this.value});
                    this._mouseUp = true;
                })));

                this.own(on(this, "mouseout", lang.hitch(this, function () {
                    this._mouseUp = false;
                })));

                this.own(on(this, "mousedragreleased", lang.hitch(this, function () {
                    if(!this._mouseUp) {
                        this.valueChanged({value: this.value});
                    }
                })));

                this.own(on(this, "keydown", lang.hitch(this, this._handleKeyDown)));

            },

            _handleKeyDown: function(event) {
                console.log(event);
                this.inherited(arguments);
                if(event.keyCode === keys.ESCAPE) {
                    this.emit("restorefocustolastnonrefuseelement");
                } else if(event.keyCode === keys.ENTER) {
                    this.emit("restorefocustolastnonrefuseelement");
                    this.emit("commit", {});
                }
            },

            valueChanged: function (value) {
            },

            _qeSetValue: function (value) {
                this.set("value", value);
                this.valueChanged({value: this.value});
            }
        });
    });
